import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { RangeQueryInterface } from '@sport-activities/sdk';

import { UpdateFilterPayloadInterface } from '~/attendee/interfaces/update-filter-payload.interface';
import { CtaVariantEnum } from '~/component/call-to-action/enums/variant.enum';
import { propertyHasBeenEmptied } from '~/core/helpers/lifecycle-hooks/on-changes/property-has-been-emptied.helper';

const FIELD_NAME = 'priceRange';

@Component({
  selector: 'app-attendee-price-filter',
  templateUrl: './price-filter.component.html',
})
export class PriceFilterComponent implements OnInit, OnChanges {
  // default range vale
  // for now, no cast is done so it's a string .. we need to auto cast to int the range filters
  @Input() public defaultRange?: RangeQueryInterface<string>;

  // emit filter value
  @Output() public selected = new EventEmitter<
    UpdateFilterPayloadInterface<RangeQueryInterface<number>>[]
  >();

  public readonly ctaVariant = CtaVariantEnum;

  public hasSelectedFilters: boolean;
  public priceForm: FormGroup;

  // maybe move this to unleash to let the country manage their list ?
  public priceRangeConfig: {
    label: string;
    values: RangeQueryInterface<number>;
  }[] = [
    {
      label: 'attendee.price.modal.free_activity.label',
      values: {
        gte: 0,
        lte: 0,
      },
    },
    {
      label: 'attendee.price.modal.paid_activity.label',
      values: {
        gt: 0,
      },
    },
  ];

  constructor(private readonly formBuilder: FormBuilder) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (propertyHasBeenEmptied(changes, 'defaultRange')) {
      this.reset();
    }
  }

  public ngOnInit(): void {
    // setup form
    this.priceForm = this.formBuilder.group({
      price: ['', Validators.required],
    });

    // parse default value
    if (!this.defaultRange) {
      return;
    }

    // default range is in string, casting it to have something
    // we can compare to the config.*.values attribute
    const castedRange: RangeQueryInterface<number> = {};
    Object.keys(this.defaultRange).forEach((key) => {
      castedRange[key] = +this.defaultRange[key];
    });

    // set selected value based on config
    this.priceRangeConfig.forEach((config) => {
      // quick way to make a deep equal
      // move this to a deepShallowEqual helper ?
      if (JSON.stringify(config.values) === JSON.stringify(castedRange)) {
        this.price.setValue(config.label);
      }
    });

    this.setChipSelectedState();
  }

  // helper for FormControl
  public get price(): FormControl {
    return this.priceForm.get('price') as FormControl;
  }

  public reset(): void {
    // reset checkboxes
    this.price.setValue(null);

    // emit empty filter
    this.selected.emit([{ field: FIELD_NAME, value: null, type: 'RANGE' }]);

    this.setChipSelectedState();
  }

  public setChipSelectedState(): void {
    this.hasSelectedFilters = this.priceForm.get('price').value;
  }

  public update(): void {
    // find selected config by label
    const priceRange = this.priceRangeConfig.find(
      (c) => c.label === this.price.value
    );

    // emit filter values
    this.selected.emit([
      {
        field: FIELD_NAME,
        value: priceRange.values,
        type: 'RANGE',
      },
    ]);

    this.setChipSelectedState();
  }
}
